import DataTable from 'datatables.net-dt';
import 'datatables.net-buttons-dt';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import languageUK from 'datatables.net-plugins/i18n/uk.mjs';

export default () => ({
    dataset: [],
    columns: [],
    reportTable: null,

    init () {
        this.dataset = JSON.parse(this.$root.dataset.dataset.replaceAll("\\", ""))
        this.columns = JSON.parse(this.$root.dataset.columns.replaceAll("\\", ""))

        jQuery(() => {
            this.reportTable = new DataTable("#testReportTable", {
                data: this.dataset,
                pageLength: 10,
                deferRender: true,
                fixedHeader: true,
                responsive: true,
                scrollX: true,
                autoWidth: true,
                language: languageUK,
                fixedColumns: {
                    start: 2
                },
                layout: {
                    top2Start: {
                        buttons: [
                            'csv'
                        ]
                    },
                    top2End: {
                        paging: {
                            numbers: true
                        }
                    },
                    topEnd: {
                        search: {
                            boundary: true
                        }
                    }
                },
                columns: this.columns
            })
        })
    }
})